import React, { useEffect } from "react";
import useHover from "../../hooks/useHover";

const makeSimpleButton = ({
  description,
  onClick,
  payload,
  icon,
  width,
  height,
  backgroundColor,
  textColor,
  borderColor,
  selectedItem,
  hoverDescription,
  hoverColor,
}) => {
  return {
    description,
    onClick,
    payload,
    icon,
    width,
    height,
    backgroundColor,
    textColor,
    borderColor,
    selectedItem,
    hoverDescription,
    hoverColor,
  };
};

const SimpleButton = ({
  description,
  onClick,
  payload,
  icon,
  width,
  height,
  backgroundColor,
  textColor,
  borderColor,
  selectedItem,
  hoverDescription,
  hoverColor,
}) => {
  const hover = useHover(hoverDescription);
  const [selected, setSelected] = React.useState(false);

  useEffect(() => {
    if (selectedItem) {
      setSelected(selectedItem === payload);
    }
  }, [selectedItem]);
  return (
    <div
      {...hover.divProps}
      onClick={() => onClick(payload)}
      className="divRow"
      style={{
        cursor: "pointer",
        opacity: selected ? 1 : 0.5,
        width,
        height,
        backgroundColor: hover.hover ? hoverColor : backgroundColor,
        border: borderColor ? `2px solid ${borderColor}` : null,
        padding: "5px",
        borderRadius: ".5rem/.5rem",
      }}
    >
      {icon ? (
        <img src={icon} className="icon25" style={{ width: "25px" }} />
      ) : null}
      <div
        className="textBold"
        style={{ color: textColor ?? "black", flex: 1, textAlign: "center" }}
      >
        {description}
      </div>
    </div>
  );
};

export default SimpleButton;
export { makeSimpleButton };
